import { MeetingType } from '../../../types'

export const meetingTagUiProps = (
  translation: (tk: string) => string,
): { tagColor: (type: MeetingType) => 'red' | 'gold' | 'cyan' | 'blue' | 'lime'; tagName: (type: MeetingType) => string } => {
  const t = translation

  const tagColor = (type: MeetingType): 'red' | 'gold' | 'cyan' | 'blue' | 'lime' => {
    if (type === MeetingType.Appraisal) {
      return 'red'
    }
    if (type === MeetingType.AppraisalUpdate) {
      return 'gold'
    }
    if (type === MeetingType.OtherGeneric) {
      return 'cyan'
    }
    if (type === MeetingType.OtherProbationTalk) {
      return 'blue'
    }
    if (type === MeetingType.OtherProjectFeedback) {
      return 'lime'
    }
    return 'cyan' // return default
  }

  const tagName = (type: MeetingType): string => {
    return t(`meetingTypes.${type}`)
  }
  return { tagColor, tagName }
}
